import _ from 'lodash'

import i18n from '@/i18n/i18n'
import { RankService } from '@/services/admin/RankService'
import { errorMessage } from '@/utilities/helpers'

const { t } = i18n.global

export const namespaced = true

export const state = {
  ranks: null,
  rank: {}
}

export const mutations = {
  SET_RANKS(state, ranks) {
    state.ranks = ranks
  },
  SET_RANK(state, rank) {
    state.rank = rank
    let index = _.findIndex(state.ranks, item => item.id === rank.id)
    if (index === -1) {
      return
    }
    state.ranks[index] = rank
  },
  ADD_RANK(state, rank) {
    state.ranks.push(rank)
  },
  DELETE_RANK(state, rankId) {
    state.ranks = _.filter(state.ranks, function (rank) {
      return rank.id !== rankId
    })
  }
}

export const getters = {
  getRankById: state => id => {
    return state.ranks ? state.ranks.find(rank => rank.id === id) : false
  }
}

export const actions = {
  getRanks({ commit, dispatch, state }) {
    if (state.ranks) return state.ranks

    return new Promise((resolve, reject) => {
      RankService.getRanks()
        .then(response => {
          commit('SET_RANKS', response.data)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.get_ranks_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getRank({ commit, state, getters }, id) {
    if (id === state.rank.id) return state.rank

    let rank = getters.getRankById(id)

    if (rank) {
      commit('SET_RANK', rank)
      return rank
    } else {
      return new Promise(resolve => {
        RankService.getRank(id).then(response => {
          commit('SET_RANK', response.data)
          resolve(response.data)
        })
      })
    }
  },
  createRank({ commit, dispatch }, rank) {
    return new Promise((resolve, reject) => {
      RankService.createRank(rank)
        .then(response => {
          commit('ADD_RANK', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.create_rank_error') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateRank({ commit, dispatch }, rank) {
    return new Promise((resolve, reject) => {
      RankService.updateRank(rank)
        .then(response => {
          commit('SET_RANK', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.update_rank_error') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteRank({ commit, dispatch }, rank) {
    return new Promise((resolve, reject) => {
      RankService.deleteRank(rank.id)
        .then(response => {
          commit('DELETE_RANK', rank.id)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.delete_rank_error') + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  importRetailers({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      RankService.importRetailers(form, form.rank_id)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.import_start', {
              element: t('store.admin.rank.retailer')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.import_retailers_error') + ' ' + errorMessage(err)
          }

          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  removeRetailer({ dispatch }, form) {
    return new Promise((resolve, reject) => {
      RankService.removeRetailer(form.rank_id, form.retailer_id)
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.rank.remove_retailer_error') + ' ' + errorMessage(err)
          }

          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
